import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";
import { RouteInterface } from "./interface/InterfaceRegisterVehicle";

export const postDriver = (data:RouteInterface) => {
    return httpConsulta.post(`/insertMotorista`, data);
}

export const postVehicle = (data:RouteInterface) => {
    return httpConsulta.post(`/insertVeiculo`, data);
}

export const getVehicle = (data:string) => {
    return httpConsulta.post(`/getVeiculoByCd?cd=${data}`);
} 

export const getDrivers = (data:string) =>{
    return httpConsulta.get(`/getByCdVinculoMotorista?cd=${data}`);
}

export const getTypeVehicle = () =>{
    return httpConsulta.get(`/getAllTipoVeiculo`);
}

export const updateDrivers = (data: RouteInterface)=>{
    return httpConsulta.post(`/updateMotorista`, data);
}
